export const en = {
  advance: 'Advance 10 seconds',
  play: 'Play',
  playbackSpeed: 'Playback speed',
  readAloud: 'Read this book aloud',
  review: 'Review 10 seconds',
};

export const es = {
  advance: 'Avance 10 segundos',
  play: 'Jugar',
  playbackSpeed: 'Velocidad de reproducción',
  readAloud: 'Lee este libro en voz alta',
  review: 'Revisar 10 segundos',
};
